@if (data) {
  <h2 mat-dialog-title>
    {{ 'ADMIN_PAGE.USERS.TABLE.DIALOG.MODIFY.TITLE' | translate }}
  </h2>
} @else {
  <h2 mat-dialog-title>
    {{ 'ADMIN_PAGE.USERS.TABLE.DIALOG.ADD.TITLE' | translate }}
  </h2>
}

<mat-dialog-content
  class="!grid grid-cols-2 gap-4"
  [attr.aria-label]="
    'ADMIN_PAGE.USERS.TABLE.DIALOG.TITLE_ARIA_LABEL' | translate
  "
  [formGroup]="userForm"
>
  @if (data) {
    <p class="col-span-2">
      {{ 'ADMIN_PAGE.USERS.TABLE.DIALOG.MODIFY.SUBTITLE' | translate }}
    </p>
  } @else {
    <p class="col-span-2">
      {{ 'ADMIN_PAGE.USERS.TABLE.DIALOG.ADD.SUBTITLE' | translate }}
    </p>
  }
  <mat-form-field appearance="fill">
    <mat-label>
      {{ 'ADMIN_PAGE.USERS.TABLE.DIALOG.FIELDS.BADGE_NUMBER' | translate }}
    </mat-label>
    <input matInput formControlName="badgeNumber" />
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>
      {{ 'ADMIN_PAGE.USERS.TABLE.DIALOG.FIELDS.FIRSTNAME' | translate }}
    </mat-label>
    <input matInput formControlName="firstName" />
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>
      {{ 'ADMIN_PAGE.USERS.TABLE.DIALOG.FIELDS.LASTNAME' | translate }}
    </mat-label>
    <input matInput formControlName="lastName" />
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>
      {{ 'ADMIN_PAGE.USERS.TABLE.DIALOG.FIELDS.EMAIL' | translate }}
    </mat-label>
    <input matInput formControlName="email" />
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>
      {{ 'ADMIN_PAGE.USERS.TABLE.DIALOG.FIELDS.LEVEL' | translate }}
    </mat-label>
    <mat-select formControlName="level">
      <mat-option *ngFor="let level of userLevels" [value]="level">
        {{ level }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>
      {{ 'ADMIN_PAGE.USERS.TABLE.DIALOG.FIELDS.ROLE' | translate }}
    </mat-label>
    <mat-select formControlName="role">
      @for (role of userRoles; track role) {
        <mat-option [value]="role">
          {{ 'USER.ROLE.' + role | translate }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>
      {{ 'ADMIN_PAGE.USERS.TABLE.DIALOG.FIELDS.TITLE' | translate }}
    </mat-label>
    <mat-select formControlName="title">
      @for (title of userTitles; track title) {
        <mat-option [value]="title">
          {{ title }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>
      {{ 'ADMIN_PAGE.USERS.TABLE.DIALOG.FIELDS.ENABLED' | translate }}
    </mat-label>
    <mat-select formControlName="enabled">
      <mat-option [value]="true">
        {{ 'USER.ENABLED.TRUE' | translate }}
      </mat-option>
      <mat-option [value]="false">
        {{ 'USER.ENABLED.FALSE' | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button (click)="onNoClick()">
    {{ 'ADMIN_PAGE.USERS.TABLE.ACTIONS.CANCEL' | translate }}
  </button>
  <button
    mat-button
    [mat-dialog-close]=""
    cdkFocusInitial
    (click)="onSave()"
    [disabled]="!userForm.valid"
  >
    @if (data) {
      {{ 'ADMIN_PAGE.USERS.TABLE.ACTIONS.MODIFY' | translate }}
    } @else {
      {{ 'ADMIN_PAGE.USERS.TABLE.ACTIONS.SAVE' | translate }}
    }
  </button>
</mat-dialog-actions>
